import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Calendar, Tag, ArrowLeft } from "lucide-react";
import api from "@/lib/api";

export function NewsList() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/news?limit=24").then((r) => setItems(r.data)); }, []);
  return (
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-16">
      <div className="eyebrow eyebrow-dark">Actualités</div>
      <h1 className="mt-2 text-3xl sm:text-4xl font-bold text-unisic-blue">Fil des actualités</h1>
      <span className="divider-gold mt-3" />
      <div className="mt-10 grid gap-6 md:grid-cols-2 lg:grid-cols-3">
        {items.length === 0 && (
          <div className="col-span-full paper-card p-10 text-center text-slate-500">Aucune actualité publiée.</div>
        )}
        {items.map((n) => (
          <Link to={`/actualites/${n.id}`} key={n.id} className="paper-card card-hover overflow-hidden flex flex-col">
            {n.image_url && <img src={n.image_url} alt={n.title} className="h-44 w-full object-cover" />}
            <div className="p-6 flex-1 flex flex-col">
              <div className="text-[11px] uppercase tracking-widest text-unisic-gold font-semibold">{n.category}</div>
              <h3 className="mt-2 font-display font-semibold text-unisic-blue leading-snug">{n.title}</h3>
              <p className="mt-3 text-sm text-slate-600 line-clamp-3 flex-1">{n.summary}</p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}

export function NewsDetail() {
  const { id } = useParams();
  const [n, setN] = useState(null);
  useEffect(() => { api.get(`/news/${id}`).then((r) => setN(r.data)); }, [id]);
  if (!n) return <div className="mx-auto max-w-3xl px-4 py-16 text-slate-500">Chargement...</div>;
  return (
    <article className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8 py-16">
      <Link to="/actualites" className="text-sm text-slate-500 hover:text-unisic-blue flex items-center gap-1">
        <ArrowLeft className="w-4 h-4" /> Toutes les actualités
      </Link>
      <div className="mt-6 text-[11px] uppercase tracking-widest text-unisic-gold font-semibold">{n.category}</div>
      <h1 className="mt-2 text-3xl sm:text-4xl font-bold text-unisic-blue leading-tight">{n.title}</h1>
      <div className="mt-4 text-sm text-slate-500 flex items-center gap-4">
        <span className="flex items-center gap-1"><Calendar className="w-3.5 h-3.5" />{new Date(n.created_at).toLocaleDateString("fr-FR")}</span>
        <span className="flex items-center gap-1"><Tag className="w-3.5 h-3.5" />{n.category}</span>
      </div>
      {n.image_url && <img src={n.image_url} alt={n.title} className="mt-8 w-full aspect-video object-cover rounded-sm" />}
      <div className="mt-8 text-slate-700 leading-relaxed whitespace-pre-line">{n.body}</div>
    </article>
  );
}
